import request from "../utils/request";

export default {
  /**
   * 动漫相关接口
   */
  // 获取视频列表
  lsjComicsList(params) {
    return request({
      url: '/laosiji/comics/search',
      type: 'post',
      params
    })
  },

  // 获取视频列表
  lsjComicsDel(params) {
    return request({
      url: '/laosiji/comics/search',
      type: 'post',
      params
    })
  },
  lsjComicsDetail(params) {
    return request({
      url: '/laosiji/comics/detail',
      type: 'post',
      params
    })
  },
  lsjComicsAdd(params) {
    return request({
      url: '/laosiji/comics/add',
      type: 'post',
      params
    })
  },
  /**
   * 小说相关接口
   */

  // 获取视频列表
  lsjNovelList(params) {
    return request({
      url: '/laosiji/novel/search',
      type: 'post',
      params
    })
  },

  // 获取视频列表
  lsjNovelDel(params) {
    return request({
      url: '/laosiji/novel/search',
      type: 'post',
      params
    })
  },
  lsjNovelDetail(params) {
    return request({
      url: '/laosiji/novel/detail',
      type: 'post',
      params
    })
  },
  lsjNovelAdd(params) {
    return request({
      url: '/laosiji/novel/add',
      type: 'post',
      params
    })
  },

  /**
   * 帖子相关接口
   */
  // 获取视频列表
  lsjPostList(params) {
    return request({
      url: '/laosiji/post/search',
      type: 'post',
      params
    })
  },

  // 获取视频列表
  lsjPostDel(params) {
    return request({
      url: '/laosiji/post/search',
      type: 'post',
      params
    })
  },
  lsjPostDetail(params) {
    return request({
      url: '/laosiji/post/detail',
      type: 'post',
      params
    })
  },
  lsjPostAdd(params) {
    return request({
      url: '/laosiji/post/add',
      type: 'post',
      params
    })
  },

  /**
   * 视频相关接口
   */
  // 获取视频列表
  lsjVideoList(params) {
    return request({
      url: '/laosiji/movie/search',
      type: 'post',
      params
    })
  },

  // 获取视频列表
  lsjVideoDel(params) {
    return request({
      url: '/laosiji/movie/search',
      type: 'post',
      params
    })
  },
  lsjVideoDetail(params) {
    return request({
      url: '/laosiji/movie/detail',
      type: 'post',
      params
    })
  },
  lsjVideoAdd(params) {
    return request({
      url: '/laosiji/movie/add',
      type: 'post',
      params
    })
  }
}